import { Badge, Box, Button, Flex, Heading, Link, Text, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DocumentsQuery } from 'generated/graphql';
import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';

type Document = NonNullable<DocumentsQuery['documents']['edges'][number]['node']>;

interface Props {
  document: Document;
}

function FileInfo({ document }: Props) {
  return (
    <Flex align="center" py={2}>
      <FontAwesomeIcon icon={['fal', 'file-lines']} size="lg" />
      <Box ml={4}>
        <Heading as="h5" size="sm">
          {document.name}
        </Heading>
        <Text fontSize="sm">Created on {moment(document.createdAt).format('lll')}</Text>
      </Box>
      <Box ml="auto">
        {document.status === 'completed' ? (
          <Badge colorScheme="green">Complete</Badge>
        ) : (
          <Tooltip label="Document request was sent to client" hasArrow>
            <Badge>In progress</Badge>
          </Tooltip>
        )}
      </Box>
    </Flex>
  );
}

function File({ document }: Props) {
  return (
    <Flex align="center">
      <Box flex={1}>
        {document.fileUrl ? (
          <Link href={document.fileUrl} isExternal _hover={{ textDecoration: 'none' }}>
            <FileInfo document={document} />
          </Link>
        ) : (
          <FileInfo document={document} />
        )}
      </Box>
      <Tooltip label="Renew">
        <Button
          as={RouterLink}
          to={document.fileUrl ? `documents/${document.id}/renew` : '#'}
          variant="ghost"
          ml={2}
          disabled={!document.fileUrl}
        >
          <FontAwesomeIcon icon={['fal', 'repeat']} size="lg" />
        </Button>
      </Tooltip>
      <Tooltip label="Settings">
        <Button
          as={RouterLink}
          to={document.fileUrl ? `documents/${document.id}/settings` : '#'}
          variant="ghost"
          ml={2}
          disabled={!document.fileUrl}
        >
          <FontAwesomeIcon icon={['fal', 'gear']} size="lg" />
        </Button>
      </Tooltip>
    </Flex>
  );
}

export default File;
